import { render, staticRenderFns } from "./TabelaDinamicaDashboardLaudos.vue?vue&type=template&id=1d63269e&scoped=true&lang=pug"
import script from "./TabelaDinamicaDashboardLaudos.vue?vue&type=script&lang=js"
export * from "./TabelaDinamicaDashboardLaudos.vue?vue&type=script&lang=js"
import style0 from "./TabelaDinamicaDashboardLaudos.vue?vue&type=style&index=0&id=1d63269e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63269e",
  null
  
)

export default component.exports